@file:OptIn(InternalResourceApi::class)

package nnod.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/nnod.ui.generated.resources/"

@delegate:ResourceContentHash(-1_552_097_621)
internal val Res.font.GenSekiGothicJP_B: FontResource by lazy {
      FontResource("font:GenSekiGothicJP_B", setOf(
        ResourceItem(setOf(), "${MD}font/GenSekiGothicJP_B.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_912_721_995)
internal val Res.font.GenSekiGothicJP_R: FontResource by lazy {
      FontResource("font:GenSekiGothicJP_R", setOf(
        ResourceItem(setOf(), "${MD}font/GenSekiGothicJP_R.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-633_095_814)
internal val Res.font.NnodCJK: FontResource by lazy {
      FontResource("font:NnodCJK", setOf(
        ResourceItem(setOf(), "${MD}font/NnodCJK.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("GenSekiGothicJP_B", Res.font.GenSekiGothicJP_B)
  map.put("GenSekiGothicJP_R", Res.font.GenSekiGothicJP_R)
  map.put("NnodCJK", Res.font.NnodCJK)
}
